import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Credentials from "./sections/Credentials";
import Experience from "./sections/Experience";
import Fleet from "./sections/Fleet";
import Invitation from "./sections/Invitation";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
import Reviews from "./sections/Reviews";
export default function HomePage() {
  return <div>
      <Navigation />
      <Hero />
      <Credentials />
      <Reviews />
      <Experience />
      <Fleet />
      <Invitation />
      <Testimonials />
      <Footer />
    </div>;
}